<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Corrections</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!--<b-button variant="dark" @click="downloadcsv()">Export</b-button>-->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
            <b-tabs content-class="mt-3">
                <b-tab title="Location" active>
                    <b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="locations" :fields="fields" >
                        <template v-slot:cell(no_of_fittings)="row">
                            <a :href="'/controllers/'+row.item.feeder_pillar_no" v-if="row.item.connections > 0"><b-badge pill variant="success">{{row.item.connections}}</b-badge></a>
                            <b-badge pill variant="success" v-else>{{row.item.no_of_fittings}}</b-badge>
                        </template>
                        <template v-slot:cell(maintenance)="row">
                            <b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
                            <b-badge pill variant="secondary" v-else>NO</b-badge>
                        </template>
                        <template v-slot:cell(door_status)="row">
                            <b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
                            <b-badge pill variant="success" v-else>CLOSED</b-badge>
                        </template>
                        <template v-slot:cell(feeder_pillar_no)="row">
                            <b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
                        </template>
                        <template v-slot:cell(connection_status)="row">
                            <b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">DATA FAULT</b-badge></div></b-link>
                            <b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
                            <b-badge pill variant="success" v-else>CONNECTED</b-badge>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-button pill variant="primary" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','edit')" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="gear-fill" font-scale="2" ></b-icon></b-button>
                        </template>
                    </b-table>
                </b-tab>
                <b-tab title="Last Data">
                    <b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="translastdata" :fields="fields" >
                        <template v-slot:cell(no_of_fittings)="row">
                            <a :href="'/controllers/'+row.item.feeder_pillar_no" v-if="row.item.connections > 0"><b-badge pill variant="success">{{row.item.connections}}</b-badge></a>
                            <b-badge pill variant="success" v-else>{{row.item.no_of_fittings}}</b-badge>
                        </template>
                        <template v-slot:cell(maintenance)="row">
                            <b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
                            <b-badge pill variant="secondary" v-else>NO</b-badge>
                        </template>
                        <template v-slot:cell(door_status)="row">
                            <b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
                            <b-badge pill variant="success" v-else>CLOSED</b-badge>
                        </template>
                        <template v-slot:cell(feeder_pillar_no)="row">
                            <b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
                        </template>
                        <template v-slot:cell(connection_status)="row">
                            <b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">DATA FAULT</b-badge></div></b-link>
                            <b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
                            <b-badge pill variant="success" v-else>CONNECTED</b-badge>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-button pill variant="primary" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','edit')" @click="updateLastData(row.item)" size="sm"><b-icon icon="gear-fill" font-scale="2" ></b-icon></b-button>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
			

			
			
			<b-modal id="edit-model" title="" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="selectedItem.imei_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Meter Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.meter_type">
									<b-form-select-option value="3P">3 Phase</b-form-select-option>
									<b-form-select-option value="1P">1 Phase</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="selectedItem.device_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
							</b-form-group>
							<b-alert show variant="secondary" class="header-title">Map Information</b-alert>
							<b-form-group label="Latitude" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Location Information</b-alert>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.zone_id=0; selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Ward" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ward_id">
									<b-form-select-option value="0">--- No Ward ---</b-form-select-option>
									<b-form-select-option v-for="item in filterWards()" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							
							<b-form-group label="Previous Load" label-for="prev-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
							</b-form-group>
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">LED Information</b-alert>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="18W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_18w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="24W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_24w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="35W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_35w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="45W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_45w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="60W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_60w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="70W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_70w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="75W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_75w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="80W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_80w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="110W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_110w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="130W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_130w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="140W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_140w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="190W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_190w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="200W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_200w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
	},
	mounted(){
        this.loadzones();
		this.initload();
		this.loadwards();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			last_sync_time: '',
			zoneOptions: [],
			wards: [],
			networkfilter: -1,
			powerfilter: -1,
			zonesUrl: self.$session.get('apiurl')+'indoreapi/zone-list',
			recordUrl: self.$session.get('apiurl')+'indoreapi/devicecorrection-records',
			updateUrl: self.$session.get('apiurl')+'indoreapi/devicecorrection-update',
            locations: [],
            translastdata: [],
			fields: [
				{ key: 'feeder_pillar_no', label: 'F. No.', sortable: true, class: 'text-left' },
				{ key: 'imei_no', label: 'IMEI', sortable: true, sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true, sortDirection: 'desc' },
				{ key: 'insert_time', label: 'Insert Time' },
				{ key: 'actions', label: 'Actions', class:'text-right', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Failure', value:2}],
			selectedItem: {
                state_id: 0,
                zone_id: 0,
                ulb_id: 0,
                ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				maintenance: 0,
				previous_load: 0,
            },
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				maintenance: 0
			},
			center: { lat: 0, lng: 0 },
			zones: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
		};
	},
	methods: {
		onFilterDevices(){
			this.filteredrecords = this.filterDevices(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid = false;
				if(self.networkfilter < 0){
					//valid = true;
				}else if(self.networkfilter == 0){
					if(d.connection_status == 0 && d.data_fault == 0){
						valid = true;
					}
				}else if(self.networkfilter == 1){
					if(d.connection_status == 1 && d.data_fault == 0){
						valid = true;
					}
				}else if(self.networkfilter == 2){
					if(d.data_fault == 1){
						valid = true;
					}
				}

				if(self.powerfilter < 0){
					//valid = true;
				}else if(self.powerfilter == 0){
					if(d.output_status == 0){
						valid = true;
					}
				}else if(self.powerfilter == 1){
					
					if(d.output_status == 1){
						valid = true;
					}
				}else if(self.powerfilter == 2){
					if(d.datalength == 59){
						valid = true;
					}
				}
				if(self.networkfilter < 0 && self.powerfilter< 0){
					valid = true;
				}
				if(valid){
					return d;
				}
			});
		},
		updateTotalLoad(){
			//this.selectedItem.total_load = (parseInt(this.selectedItem.led_18w) * 18) + (parseInt(this.selectedItem.led_24w) * 24) + (parseInt(this.selectedItem.led_35w) * 35) + (parseInt(this.selectedItem.led_45w) * 45) + (parseInt(this.selectedItem.led_70w) * 70) + (parseInt(this.selectedItem.led_75w) * 75) + (parseInt(this.selectedItem.led_110w) * 110) + (parseInt(this.selectedItem.led_140w) * 140) + (parseInt(this.selectedItem.led_190w) * 190);
			//this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		
			var total_load = 0;
			if(parseInt(this.selectedItem.led_18w) > 0){
				total_load += parseInt(this.selectedItem.led_18w) * 18;
			}
			if(parseInt(this.selectedItem.led_24w) > 0){
				total_load += parseInt(this.selectedItem.led_24w) * 24;
			}
			if(parseInt(this.selectedItem.led_35w) > 0){
				total_load += parseInt(this.selectedItem.led_35w) * 35;
			}
			if(parseInt(this.selectedItem.led_45w) > 0){
				total_load += parseInt(this.selectedItem.led_45w) * 45;
			}
			if(parseInt(this.selectedItem.led_60w) > 0){
				total_load += parseInt(this.selectedItem.led_60w) * 60;
			}
			if(parseInt(this.selectedItem.led_70w) > 0){
				total_load += parseInt(this.selectedItem.led_70w) * 70;
			}
			if(parseInt(this.selectedItem.led_75w) > 0){
				total_load += parseInt(this.selectedItem.led_75w) * 75;
			}
			if(parseInt(this.selectedItem.led_80w) > 0){
				total_load += parseInt(this.selectedItem.led_80w) * 80;
			}
			if(parseInt(this.selectedItem.led_110w) > 0){
				total_load += parseInt(this.selectedItem.led_110w) * 110;
			}
			if(parseInt(this.selectedItem.led_130w) > 0){
				total_load += parseInt(this.selectedItem.led_130w) * 130;
			}
			if(parseInt(this.selectedItem.led_140w) > 0){
				total_load += parseInt(this.selectedItem.led_140w) * 140;
			}
			if(parseInt(this.selectedItem.led_190w) > 0){
				total_load += parseInt(this.selectedItem.led_190w) * 190;
			}
			if(parseInt(this.selectedItem.led_200w) > 0){
				total_load += parseInt(this.selectedItem.led_200w) * 200;
			}
			this.selectedItem.total_load = total_load;
			
			this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		},
		
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent == 0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state == self.selectedItem.state_id;
			})
		},
		filterWards(){
			var self = this;
			return self.wards.filter(function (item) {
				return item.ulb_id  == self.selectedItem.ulb_id;
			})
		},
		showUpdateModal(item, index, button) {
            this.selectedItem = Object.assign({
                state_id: 0,
                zone_id: 0,
                ulb_id: 0,
                ward_no: '',
				ccms_no: '',
				total_load: 0,
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: 0,
				location_lng: 0,
				previous_load: 0,
				maintenance: 0,
				led_fittings: '{}',
				led_18w: 0,
				led_24w: 0,
				led_35w: 0,
				led_45w: 0,
				led_60w: 0,
				led_70w: 0,
				led_75w: 0,
				led_80w: 0,
				led_110w: 0,
				led_130w: 0,
				led_140w: 0,
				led_190w: 0,
				led_200w: 0
            }, item);
            
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
			this.replaceItem = {
				replace_imei_no: item.imei_no,
				replace_meter_no: item.device_no,
				feeder_pillar_no: item.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: item.mobile_no,
				replace_time: '',
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.updateUrl, {
				accesskey: self.$session.get('access_key'),
                data: self.selectedItem,
                type: 'location'
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
        updateLastData(item){
			var self = this;
			self.loading = true;
			
			self.axios.post(self.updateUrl, {
				accesskey: self.$session.get('access_key'),
                data: item,
                type: 'translastdata'
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					/*self.zoneOptions.forEach(function(field){
						if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;//+', '+field2.title+', Maharastra';
									}
								});
								//self.page_title = field.title+', Maharastra';
							}
						}
					});*/
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadwards(){
			var self = this;
			
			self.axios.post(self.wardsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.wards = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.locations = response.data.result.locations;
                    self.translastdata = response.data.result.translastdata;
					self.loading = false;
					
					//setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
</style>